import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

// Values from the branch-motion standards (press feedback, strong ease-out). Swap for the shared
// --motion-* custom properties once they exist.
const swapTransition = 'opacity 150ms cubic-bezier(0.23, 1, 0.32, 1), transform 150ms cubic-bezier(0.23, 1, 0.32, 1)';

// Plain CSS keyed off data-state, so the morph carries over when staff-fe leaves Material-UI.
const styles = (theme) => ({
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: 0,
    border: 0,
    borderRadius: 4,
    background: 'none',
    font: 'inherit',
    color: theme.colorPalette.orange_50,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colorPalette.orange_50_op_08
    },
    ...reskinStyles(theme, {
      color: theme.colors.action_icon,
      borderRadius: 22,
      '&:hover': { backgroundColor: theme.colorPalette.beige_50 }
    }),
    '&:disabled': {
      cursor: 'default'
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.colorPalette.orange_50}`,
      outlineOffset: 2
    },
    '&[data-state="copied"] $copyIcon': {
      opacity: 0
    },
    '&[data-state="copied"] $checkIcon': {
      opacity: 1
    }
  },
  // Both icons share one grid cell, so the button keeps its size through the swap.
  icons: {
    display: 'inline-grid',
    flexShrink: 0,
    width: 24,
    height: 24
  },
  icon: {
    gridArea: '1 / 1',
    width: '100%',
    height: '100%',
    transition: swapTransition
  },
  copyIcon: {
    opacity: 1
  },
  checkIcon: {
    opacity: 0
  },
  // Reduced motion keeps the cross-fade and drops the scale.
  '@media (prefers-reduced-motion: no-preference)': {
    button: {
      '&[data-state="copied"] $copyIcon': {
        transform: 'scale(0.95)'
      },
      '&[data-state="copied"] $checkIcon': {
        transform: 'scale(1)'
      }
    },
    checkIcon: {
      transform: 'scale(0.95)'
    }
  },
  status: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
    border: 0
  }
});

export default makeStyles(styles);
